export const booleanOptions = [
  {
    value: true,
    name: 'yes'
  },
  {
    value: false,
    name: 'no'
  },
]

export const commonOptions = [
  {
    id: 2,
    name: 'clinical.people.anamnesis.common_options.yes'
  },
  {
    id: 1,
    name: 'clinical.people.anamnesis.common_options.sometimes'
  },
  {
    id: 0,
    name: 'clinical.people.anamnesis.common_options.no'
  }
]

export const hearingLossTypeOptions = [
  {
    id: 1,
    name: 'clinical.people.anamnesis.hearing_loss_types.no_loss',
  },
  {
    id: 2,
    name: 'clinical.people.anamnesis.hearing_loss_types.progressive',
  },
  {
    id: 3,
    name: 'clinical.people.anamnesis.hearing_loss_types.sudden',
  }
]

export const tinnitusLocationOptions = [
  {
    id: 1,
    name: 'no'
  },
  {
    id: 2,
    name: 'clinical.people.anamnesis.tinitus_locations.unilateral_le'
  },
  {
    id: 3,
    name: 'clinical.people.anamnesis.tinitus_locations.unilateral_re'
  },
  {
    id: 4,
    name: 'clinical.people.anamnesis.tinitus_locations.bilateral'
  },
  {
    id: 5,
    name: 'clinical.people.anamnesis.tinitus_locations.centralized'
  }
]

export const tinnitusTypeOptions = [
  {
    id: 1,
    name: 'clinical.people.anamnesis.tinitus_types.pulsatile'
  },
  {
    id: 2,
    name: 'clinical.people.anamnesis.tinitus_types.continuous'
  },
]

export const tinnitusToneTypeOptions = [
  {
    id: 1,
    name: 'clinical.people.anamnesis.tinitus_tone_types.bass'
  },
  {
    id: 2,
    name: 'clinical.people.anamnesis.tinitus_tone_types.acute'
  },
]

export const familyRelationTypeOptions = [
  {
    id: 1,
    name: 'clinical.people.anamnesis.family_relation_types.grand_father'
  },
  {
    id: 2,
    name: 'clinical.people.anamnesis.family_relation_types.grand_mother'
  },
  {
    id: 3,
    name: 'clinical.people.anamnesis.family_relation_types.father'
  },
  {
    id: 4,
    name: 'clinical.people.anamnesis.family_relation_types.mother'
  },
  {
    id: 5,
    name: 'clinical.people.anamnesis.family_relation_types.uncle'
  },
  {
    id: 6,
    name: 'clinical.people.anamnesis.family_relation_types.aunt'
  },
  {
    id: 7,
    name: 'clinical.people.anamnesis.family_relation_types.brother'
  },
  {
    id: 8,
    name: 'clinical.people.anamnesis.family_relation_types.sister'
  },
  {
    id: 9,
    name: 'clinical.people.anamnesis.family_relation_types.son'
  },
  {
    id: 10,
    name: 'clinical.people.anamnesis.family_relation_types.daughter'
  },
  {
    id: 11,
    name: 'clinical.people.anamnesis.family_relation_types.grand_son'
  },
  {
    id: 12,
    name: 'clinical.people.anamnesis.family_relation_types.grand_daughter'
  },
  {
    id: 13,
    name: 'clinical.people.anamnesis.family_relation_types.cousin'
  },
  {
    id: 14,
    name: 'clinical.people.anamnesis.family_relation_types.wife'
  },
  {
    id: 15,
    name: 'clinical.people.anamnesis.family_relation_types.husband'
  },
  {
    id: 16,
    name: 'clinical.people.anamnesis.family_relation_types.another_family_member'
  },
  {
    id: 17,
    name: 'clinical.people.anamnesis.family_relation_types.friend'
  },
]

export const previousHearingAidOptions = [
  {
    id: 1,
    name: 'no'
  },
  {
    id: 2,
    name: 'clinical.people.anamnesis.left_ear'
  },
  {
    id: 3,
    name: 'clinical.people.anamnesis.right_ear'
  },
  {
    id: 4,
    name: 'clinical.labels.both'
  },
]

export const hearingDifficultyEnvironments = [
  {
    id: 1,
    name: 'clinical.people.anamnesis.hearing_difficulty_environments.churches'
  },
  {
    id: 2,
    name: 'clinical.people.anamnesis.hearing_difficulty_environments.work'
  },
  {
    id: 3,
    name: 'clinical.people.anamnesis.hearing_difficulty_environments.television'
  },
  {
    id: 4,
    name: 'clinical.people.anamnesis.hearing_difficulty_environments.groups'
  },
  {
    id: 5,
    name: 'clinical.people.anamnesis.hearing_difficulty_environments.shopping'
  },
  {
    id: 6,
    name: 'clinical.people.anamnesis.hearing_difficulty_environments.door_bells'
  },
  {
    id: 7,
    name: 'clinical.people.anamnesis.hearing_difficulty_environments.isolation'
  },
  {
    id: 8,
    name: 'clinical.people.anamnesis.hearing_difficulty_environments.theaters'
  },
  {
    id: 9,
    name: 'clinical.people.anamnesis.hearing_difficulty_environments.meetings'
  },
  {
    id: 10,
    name: 'clinical.people.anamnesis.hearing_difficulty_environments.car'
  }
]

export const otoscopyEarResults = [
  {
    id: 1,
    name: 'clinical.people.anamnesis.otoscopyEarResults.normal'
  },
  {
    id: 2,
    name: 'clinical.people.anamnesis.otoscopyEarResults.obliterating_cerumen'
  },
  {
    id: 3,
    name: 'clinical.people.anamnesis.otoscopyEarResults.non_obliterating_cerumen'
  },
  {
    id: 4,
    name: 'clinical.people.anamnesis.otoscopyEarResults.infection'
  },
  {
    id: 5,
    name: 'clinical.people.anamnesis.otoscopyEarResults.other'
  }
]

export const otoscopyEardrumResults = [
  {
    id: 1,
    name: 'clinical.people.anamnesis.otoscopyEardrumResults.normal'
  },
  {
    id: 2,
    name: 'clinical.people.anamnesis.otoscopyEardrumResults.non_visible'
  },
  {
    id: 3,
    name: 'clinical.people.anamnesis.otoscopyEardrumResults.perforation'
  },
  {
    id: 4,
    name: 'clinical.people.anamnesis.otoscopyEardrumResults.dull_membrane'
  },
  {
    id: 5,
    name: 'clinical.people.anamnesis.otoscopyEardrumResults.infection'
  },
  {
    id: 6,
    name: 'clinical.people.anamnesis.otoscopyEardrumResults.other'
  }
]

export const supplyTypeOptions = [
  {
    id: 1,
    name: 'clinical.appointments.hearing_devices.supply_types.existing'
  },
  {
    id: 2,
    name: 'clinical.appointments.hearing_devices.supply_types.demonstration'
  },
  {
    id: 3,
    name: 'clinical.appointments.hearing_devices.supply_types.experience'
  },
  {
    id: 4,
    name: 'clinical.appointments.hearing_devices.supply_types.purchase'
  }
]

export const tonalAudiometryHearingLossTypes = [
  {
    id: 1,
    name: 'clinical.people.anamnesis.tonalAudiometryHearingLossTypes.mixed'
  },
  {
    id: 2,
    name: 'clinical.people.anamnesis.tonalAudiometryHearingLossTypes.sensorineural'
  },
  {
    id: 3,
    name: 'clinical.people.anamnesis.tonalAudiometryHearingLossTypes.conductive'
  }
]
